import React from 'react';
import { getAllLevels, getDailyChallenge, isDailyChallengeCompleted } from '../../tools/gameLevels';
import { getGameData, isLevelUnlocked } from '../../tools/gameProgress';

class GameLevelSelect extends React.Component {
    render() {
        const { onSelectLevel, onBack } = this.props;
        const levels = getAllLevels();
        const gameData = getGameData();

        // Endless mode unlocked after all 15 levels completed
        const allLevelsComplete = levels.every(l => gameData.levelStars[l.id] >= 1);

        // Daily challenge unlocked after level 3
        const dailyUnlocked = gameData.levelStars[3] >= 1;
        const dailyCompleted = isDailyChallengeCompleted();
        const daily = dailyUnlocked ? getDailyChallenge() : null;

        return (
            <div className="level-select" data-testid="level-select">
                <div className="level-select-header">
                    <a href="/welcome" className="level-back-btn" onClick={(e) => { e.preventDefault(); onBack(); }}>
                        ◀
                    </a>
                    <h1 className="level-select-title">Focus Catcher</h1>
                </div>

                {/* Special modes section */}
                <div className="special-modes">
                    {/* Daily Challenge */}
                    {dailyUnlocked && (
                        <button
                            className={`special-mode-card daily-card ${dailyCompleted ? 'completed' : ''}`}
                            data-testid="daily-challenge"
                            onClick={() => onSelectLevel('daily')}
                        >
                            <div className="special-mode-icon">{dailyCompleted ? '✅' : '📅'}</div>
                            <div className="special-mode-info">
                                <div className="special-mode-name">Daily: {daily.name}</div>
                                <div className="special-mode-desc">{daily.desc}</div>
                            </div>
                            {dailyCompleted && <div className="special-mode-badge">Done</div>}
                        </button>
                    )}

                    {/* Endless Mode */}
                    <button
                        className={`special-mode-card endless-card ${allLevelsComplete ? '' : 'locked'}`}
                        data-testid="endless-mode"
                        disabled={!allLevelsComplete}
                        onClick={() => allLevelsComplete && onSelectLevel('endless')}
                    >
                        <div className="special-mode-icon">{allLevelsComplete ? '♾️' : '🔒'}</div>
                        <div className="special-mode-info">
                            <div className="special-mode-name">Endless Mode</div>
                            <div className="special-mode-desc">
                                {allLevelsComplete
                                    ? `High: ${(gameData.endlessHighScore || 0).toLocaleString()}`
                                    : 'Complete all 15 levels'}
                            </div>
                        </div>
                    </button>
                </div>

                {/* Level grid */}
                <div className="level-grid">
                    {levels.map(level => {
                        const unlocked = isLevelUnlocked(level.id);
                        const stars = gameData.levelStars[level.id] || 0;
                        const highScore = gameData.levelHighScores[level.id] || 0;

                        return (
                            <button
                                key={level.id}
                                data-testid={`level-${level.id}`}
                                className={`level-card ${unlocked ? '' : 'locked'}`}
                                disabled={!unlocked}
                                onClick={() => unlocked && onSelectLevel(level.id)}
                            >
                                <div className="level-number">{level.id}</div>
                                <div className="level-name">{level.name}</div>
                                <div className="level-stars">
                                    {[1, 2, 3].map(i => (
                                        <span key={i} className={stars >= i ? 'star-filled' : 'star-empty'}>★</span>
                                    ))}
                                </div>
                                {highScore > 0 && (
                                    <div className="level-highscore">{highScore.toLocaleString()}</div>
                                )}
                                {!unlocked && <div className="level-lock">🔒</div>}
                            </button>
                        );
                    })}
                </div>

                {gameData.totalGamesPlayed > 0 && (
                    <div className="level-select-stats">
                        <div>
                            ★ {Object.values(gameData.levelStars).reduce((a, b) => a + b, 0)}/45
                            <span> · Best Combo: {gameData.bestCombo}x</span>
                        </div>
                        {gameData.bestReactionTime && (
                            <div>Best Reaction: {gameData.bestReactionTime}ms</div>
                        )}
                        {gameData.achievements && Object.keys(gameData.achievements).length > 0 && (
                            <div>🏅 {Object.keys(gameData.achievements).length} achievements</div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default GameLevelSelect;
